module.exports = __webpack_public_path__ + "img/spanish_app_store.6c45936d.png";